export function resolveDrawerCloseType(closeType: string) {
  switch (closeType) {
    case 'outside-click':
      return 'Close-Out';
    case 'icon':
      return 'Close-X';
    case 'slide-down':
      return 'Close-Slide';
    case 'slide-down-position-velocity':
      return 'Close-Slide-Position-Velocity';
    case 'slide-down-position':
      return 'Close-Slide-Position';
    case 'slide-down-velocity':
      return 'Close-Slide-Velocity';
    case 'escape':
      return 'Escape';
    case 'browser-back':
      return 'Browser-Back';
    default:
      return 'Close';
  }
}
